import Immutable from 'immutable';
import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};
const setDateFilter = (state, { selectedDuration }) => {
  return state.merge({ selectedDuration });
};
const setGlobalKpiDashboard = (state, { globalKpiDashboard }) => {
  return state.merge({ globalKpiDashboard });
};
const setKpiDetailDashboard = (state, { kpiDetailDashboard }) => {
  return state.merge({ kpiDetailDashboard });
};
const setSiteKpiDashboard = (state, { siteKpiDetailDashboard }) => {
  return state.merge({ siteKpiDetailDashboard });
};
const setMapGlobalDashboard = (state, { mapGlobalDashboard }) => {
  return state.merge({ mapGlobalDashboard });
};
const setGlobalAssetUtilization = (state, { globalAssetUtilization }) => {
  return state.merge({ globalAssetUtilization });
};
const setSiteAssetUtilization = (state, { siteAssetUtilization }) => {
  return state.merge({ siteAssetUtilization });
};
const setSitePerformanceDetail = (state, { sitePerformanceDetail }) => {
  return state.merge({ sitePerformanceDetail });
};
const setSelectedKpiDetail = (state, { selectedKpiDetail }) => {
  return state.merge({ selectedKpiDetail });
};
const setKpiList = (state, { kpiList }) => {
  return state.merge({ kpiList });
};
const setAllKpiByUser = (state, { allKpiByUser }) => {
  return state.merge({ allKpiByUser });
};
const setUserKpiList = (state, { userKpiList }) => {
  return state.merge({ userKpiList });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_Loader,
    actionFunction: setLoader,
  },
  {
    actionType: ActionTypes.SET_GLOBAL_DASHBOARD_DATE_FILTER,
    actionFunction: setDateFilter,
  },
  {
    actionType: ActionTypes.SET_GLOBAL_KPI_DASHBOARD,
    actionFunction: setGlobalKpiDashboard,
  },
  {
    actionType: ActionTypes.SET_KPI_DETAIL_DASHBOARD,
    actionFunction: setKpiDetailDashboard,
  },
  {
    actionType: ActionTypes.SET_SITE_KPI_DASHBOARD,
    actionFunction: setSiteKpiDashboard,
  },
  {
    actionType: ActionTypes.SET_MAP_GLOBAL_DASHBOARD,
    actionFunction: setMapGlobalDashboard,
  },
  {
    actionType: ActionTypes.SET_GLOBAL_ASSET_UTILIZATION,
    actionFunction: setGlobalAssetUtilization,
  },
  {
    actionType: ActionTypes.SET_SITE_ASSET_UTILIZATION,
    actionFunction: setSiteAssetUtilization,
  },
  {
    actionType: ActionTypes.SET_SITE_PERFORMANCE_DETAIL,
    actionFunction: setSitePerformanceDetail,
  },
  {
    actionType: ActionTypes.SET_KPI_INFORMATION,
    actionFunction: setSelectedKpiDetail,
  },
  {
    actionType: ActionTypes.SET_KPI_LIST,
    actionFunction: setKpiList,
  },
  {
    actionType: ActionTypes.SET_ALL_KPI_BY_USER,
    actionFunction: setAllKpiByUser,
  },
  {
    actionType: ActionTypes.SET_USER_KPI_LIST,
    actionFunction: setUserKpiList,
  },
];
